
import React from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import StickyCTA from '../../components/feature/StickyCTA';
import Hero from './components/Hero';
import Features from './components/Features';
import HowItWorks from './components/HowItWorks';
import LatestArticles from '../articles/components/LatestArticles';
// import DiagnosisBanner from './components/DiagnosisBanner';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <Features />
        <HowItWorks />
        <LatestArticles
          maxItems={3}
          cta={{ to: '/articles', label: 'コラム一覧を見る' }}
        />
        {/* <DiagnosisBanner /> */}
      </main>
      <Footer />
      <StickyCTA />
    </>
  );
}
